import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { ApiConsumer } from '../../service/api-consumer';

import { LoginCredentials } from '../../interface/login/LoginCredentials';

import { StorageKey } from '../../enum/StorageKey';

import { setItemToSessionStorage } from '../../util/session-storage';

import { AxiosError } from 'axios';

interface Auth {
  role: string | null;
  error: string | null;
  isLoading: boolean;
}

const initialState: Auth = {
  role: null,
  error: null,
  isLoading: false,
};

export const authenticate = createAsyncThunk('/Token', async (credentials: LoginCredentials) => {
  const response = await ApiConsumer.authenticate(credentials.username, credentials.password);

  return response;
});

export const getRoleAndPermissions = createAsyncThunk('/api/UserAuthentication/Permission', async () => {
  const response = await ApiConsumer.getRoleAndPermissions();

  return response;
});

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setRole: (state, { payload }) => {
      state.role = payload;
    },

    setErrorMessage: (state, { payload }) => {
      state.error = payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(authenticate.fulfilled, (state, { payload }) => {
      setItemToSessionStorage(StorageKey.ACCESS_TOKEN, payload.access_token);
      setItemToSessionStorage(StorageKey.EXPIRY_DATE, payload['.expires']);

      state.isLoading = false;
    });

    builder.addCase(authenticate.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(authenticate.rejected, (state, action) => {
      if (action.error.code === AxiosError.ECONNABORTED) {
        state.error = 'The request took too much time to load!';
      }

      if (action.error.code === AxiosError.ERR_BAD_REQUEST) {
        state.error = 'Wrong username or password!';
      }

      if (action.error.code === AxiosError.ERR_CANCELED) {
        state.error = 'The request has been canceled!';
      }

      state.isLoading = false;
    });

    builder.addCase(getRoleAndPermissions.fulfilled, (state, { payload }) => {
      state.role = payload.UserRole;
    });

    builder.addCase(getRoleAndPermissions.rejected, (state) => {});
  },
});

export const { setRole, setErrorMessage } = authSlice.actions;

export default authSlice.reducer;
